import {
  SET_EXPIRING_TICKETS,
  DISMISS_TICKET_TOAST,
  SHOW_TICKET_MODAL,
  HIDE_TICKET_MODAL
} from "../actions/expiryActions";

const initialState = {
  expiringTickets: [],
  showToast: false,
  showModal: false
};

export default function expiryReducer(state = initialState, action) {
  switch (action.type) {
    case SET_EXPIRING_TICKETS:
      return {
        ...state,
        expiringTickets: action.payload,
        showToast: action.payload.length > 0
      };

    case DISMISS_TICKET_TOAST:
      return {
        ...state,
        showToast: false
      };

    case SHOW_TICKET_MODAL:
      return {
        ...state,
        showModal: true
      };

    case HIDE_TICKET_MODAL:
      return {
        ...state,
        showModal: false
      };

    default:
      return state;
  }
}
